import z from 'zod';
import type { ThemeSlug } from '@/types';

const envSchema = z.object({
  appUrl: z.string().url(),
  apiUrl: z.string().url(),
  authUrl: z.string().url(),
  shopUrl: z.string().url(),
  environment: z.enum(['development', 'staging', 'production']).default('development'),
  themeSlug: z.enum(['mympu', 'mymorize']),
  gtmId: z.string().optional(),
});

const envClient = envSchema.safeParse({
  appUrl: process.env.NEXT_PUBLIC_APP_URL,
  apiUrl: process.env.NEXT_PUBLIC_API_URL,
  authUrl: process.env.NEXT_PUBLIC_AUTH_URL,
  shopUrl: process.env.NEXT_PUBLIC_SHOP_URL,
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
  themeSlug: process.env.NEXT_PUBLIC_THEME_SLUG as ThemeSlug,
  gtmId: process.env.NEXT_PUBLIC_GTM_ID,
});

if (!envClient.success) {
  console.error(envClient.error.issues);
  throw new Error('Invalid environment variables!');
}

export const { appUrl, apiUrl, authUrl, shopUrl, environment, themeSlug, gtmId } = envClient.data;
